module.exports = __webpack_public_path__ + "img/Decoration_anniversaire.98b07e9.jpg";